import clsx from "clsx";
import { CalendarDays, MapPin, Flag, Globe, FlaskConical } from "lucide-react";

import { Card } from "../../../../shared/card/card.tsx";
import type { Holiday } from "../../types.ts";

import styles from "./holidays-stats.module.css";

export interface HolidaysStatsProps {
  holidays: Holiday[];
}

export function HolidaysStats({ holidays }: HolidaysStatsProps) {
  const total = holidays.length;
  const india = holidays.filter((h) => h.region === "INDIA").length;
  const us = holidays.filter((h) => h.region === "US").length;
  const uk = holidays.filter((h) => h.region === "UK").length;
  const sqe = holidays.filter((h) => h.region === "SQE").length;

  const tiles = [
    {
      key: "total",
      label: "Total Holidays",
      value: total,
      icon: CalendarDays,
      iconClass: styles.iconPurple,
    },
    {
      key: "india",
      label: "India",
      value: india,
      icon: MapPin,
      iconClass: styles.iconGreen,
    },
    {
      key: "us",
      label: "US",
      value: us,
      icon: Flag,
      iconClass: styles.iconBlue,
    },
    {
      key: "uk",
      label: "UK",
      value: uk,
      icon: Globe,
      iconClass: styles.iconAmber,
    },
    {
      key: "sqe",
      label: "SQE Labs",
      value: sqe,
      icon: FlaskConical,
      iconClass: styles.iconTeal,
    },
  ] as const;

  return (
    <div className={styles.grid}>
      {tiles.map(({ key, label, value, icon: Icon, iconClass }) => (
        <Card key={key} className={styles.card} padding="3xl" variant="default">
          <div className={styles.cardInner}>
            <span className={clsx(styles.iconWrap, iconClass)} aria-hidden>
              <Icon size={20} strokeWidth={2} />
            </span>
            <div className={styles.text}>
              <p className={clsx("sub-heading-xs", styles.label)}>{label}</p>
              <p className={clsx("heading-lg", styles.value)}>{value}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
